<template>
  <div class="ViewLKPassportIndex">
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />
    <PassportForm
      v-else-if="!!passport"
      :data="passport"
      context-always-visible
      @update:passport="fetchUserPassport"
    />
    <span v-else>{{ errMessage }}</span>
  </div>
</template>

<script>
// Components.
import PassportForm from './components/LKPassportForm.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import { LkPassportApi } from '@/api/resources'

const PASSPORT_UNDEFINED_MSG = 'Паспорт не найден'

export default {
  name: 'LKPassportIndex',
  components: { PassportForm, LKProgressCircular },
  data: () => ({
    isLoadingAsyncData: false,
    passport: null,
    errMessage: PASSPORT_UNDEFINED_MSG,
  }),
  async created() {
    await this.fetchUserPassport()
  },
  methods: {
    async fetchUserPassport() {
      this.isLoadingAsyncData = true

      try {
        const api = new LkPassportApi()
        this.passport = await api.getUserPassport()
      } catch (e) {
        if (Array.isArray(e.errors)) {
          this.errMessage = e.errors[0] ?? PASSPORT_UNDEFINED_MSG
        }

        this.$notice.errors(e)
      } finally {
        this.isLoadingAsyncData = false
      }
    },
  },
}
</script>

<style lang="scss">
.ViewLKPassportIndex {
  padding: 40px;
  background-color: $webflow-color-white;
}
</style>
